import { useScrollReveal } from '@/hooks/useScrollReveal';

const pricingItems = [
  { label: 'Per-Route / Per-Tonne', desc: 'Transparent leasing fees based on distance, load size, and temperature requirements. You see the price before you book.', icon: 'ri-route-line' },
  { label: 'No Long-Term Contracts', desc: 'Book a single load or set up recurring routes. No minimum commitment, no lock-in — use the platform on your terms.', icon: 'ri-file-list-3-line' },
  { label: 'Small Platform Fee', desc: 'Freshhlock takes a modest facilitation fee per completed load. We only earn when a load is delivered successfully.', icon: 'ri-hand-heart-line' },
];

export default function PricingSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 warm-sand-bg">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Simple Pricing
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Transparent, No Surprises
          </h2>
          <p className="text-foreground-500 max-w-lg mx-auto">
            Pay only for what you use. No hidden fees, no complicated contracts — just straightforward cold-chain transport.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {pricingItems.map((item) => (
            <div key={item.label} className="group bg-card-50 border border-card-200 rounded-xl p-6 md:p-8 text-center shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 card-animate">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-5 animate-icon-float icon-hover-pop">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-primary-700 text-base mb-3">{item.label}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}